import { cn } from "../../lib/utils";

/**
 * Placeholder block while content is loading.
 * @param {Object} props
 * @param {string} [props.className]
 * @param {React.HTMLAttributes<HTMLDivElement>} props
 * @returns {JSX.Element}
 */
function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-ui-muted", className)}
      {...props}
    />
  );
}

export { Skeleton };
